// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"ac30b461","762":"cb68e99b"}[chunkId] + ".chunk.css";
};